import { CashSalesDetail } from "../../../../types/sale.type";
import { formatNumber } from "../../../../utils";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";

interface CashSalesDetailsTableProps {
  cashSalesDetails?: CashSalesDetail[];
}

export default function CashSalesDetailsTable({
  cashSalesDetails = [],
}: CashSalesDetailsTableProps) {
  return (
    <TableContainer>
      <Table>
        <TableHead
          sx={{ bgcolor: (theme) => theme.palette.background.default }}
        >
          <TableRow>
            <TableCell align="center">ลำดับ</TableCell>
            <TableCell align="center">ชื่อสินค้า</TableCell>
            <TableCell align="center">จำนวน</TableCell>
            <TableCell align="center">หน่วย</TableCell>
            <TableCell align="center">ราคา</TableCell>
            <TableCell align="center">ส่วนลด</TableCell>
            <TableCell align="center">ราคารวม</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {cashSalesDetails.length > 0 ? (
            cashSalesDetails.map((detail, index) => (
              <TableRow
                key={detail.id || `${detail.product_code}_${index}`}
                sx={{
                  bgcolor: index % 2 === 1 ? "#f6f6f9" : "#fff",
                  "& td, & th": { padding: "8px" },
                }}
              >
                <TableCell align="center">{index + 1}</TableCell>
                <TableCell>
                  <Box>
                    <Typography fontWeight={600}>{detail.name}</Typography>
                    <Typography color="text.secondary" fontSize={14}>
                      รหัสสินค้า: {detail.product_code}
                    </Typography>
                  </Box>
                </TableCell>
                <TableCell align="center">
                  {Number(detail.qty).toLocaleString()}
                </TableCell>
                <TableCell align="center">{detail.unitname}</TableCell>
                <TableCell align="center">
                  {formatNumber(detail.price)}
                </TableCell>
                <TableCell align="center">
                  {formatNumber(detail.discount_amount)}
                </TableCell>
                <TableCell align="center">
                  {formatNumber(detail.line_total)}
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={7} align="center" sx={{ py: 4 }}>
                <Typography color="text.secondary">
                  ไม่มีข้อมูลสินค้า
                </Typography>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
